import axios from "axios";
import Swal from "sweetalert2";

const OPENDATA_BASE_URL = "https://opendata.erdenetmc.mn/api";

export function OPENDATA() {
  return createInstance(OPENDATA_BASE_URL);
}

const createInstance = (baseURL) => {
  const headers = {
    "Content-Type": "application/json,",
  };
  const token =
    typeof window !== "undefined" ? localStorage.getItem("token") : null;
  if (token != null) {
    Object.assign(headers, {
      Authorization: "SSO " + token,
    });
  }

  let api = axios.create({
    baseURL: baseURL,
    timeout: 200000,
    headers,
  });

  api.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.message !== "Network Error") {
        if (error.response.status === 400) {
          if (error.response.data.message === "No user found") {
            Swal.fire("", "Бүртгэлгүй хэрэглэгч.", "warning");
          } else {
            Swal.fire("", error.response.data.message, "warning");
          }
        }
        if (error.response.status === 401) {
          localStorage.clear();
          throw error;
        } else {
          throw error;
        }
      } else {
        Swal.fire("", error.response.data.message, "warning");
        throw error;
      }
    }
  );
  return api;
};

// Хэрэглэгчийн хувийн мэдээлэл
export async function getLogOut() {
  const response = await OPENDATA().get("/logout");
  return response;
}
export async function getUserInfo() {
  const response = await OPENDATA().get("/userinfo");
  return response.data;
}
// Лавлах
export async function searchWorker(tn) {
  const response = await OPENDATA().get("/employee/" + tn);
  return response.data;
}
export async function departments() {
  const response = await OPENDATA().get("/departments");
  return response.data;
}
// Бүлэг
export async function postputCategory(id, json) {
  if (id === 0) {
    const response = await OPENDATA().post("/category", { ...json });
    return response.data;
  } else {
    const response = await OPENDATA().put("/category/" + id, { ...json });
    return response.data;
  }
}
export async function getCategory() {
  const response = await OPENDATA().get("/category");
  return response.data;
}
export async function deleteCategory(id) {
  const response = await OPENDATA().delete("/category/" + id);
  return response.data;
}
// Гарчиг
export async function postputArticle(id, json) {
  if (id === 0) {
    const response = await OPENDATA().post("/article", { ...json });
    return response.data;
  } else {
    const response = await OPENDATA().put("/article/" + id, { ...json });
    return response.data;
  }
}
export async function getArticle() {
  const response = await OPENDATA().get("/article");
  return response.data;
}
export async function deleteArticle(id) {
  const response = await OPENDATA().delete("/article/" + id);
  return response.data;
}
// Data
export async function postAttachment(formdata) {
  const response = await OPENDATA().post("/attachment", formdata, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
}
export async function deleteAttachment(id) {
  const response = await OPENDATA().delete("/attachment/" + id);
  return response.data;
}
export async function getAttachment(id) {
  const response = await OPENDATA().get("/attachment/" + id, {
    responseType: "blob",
  });
  return response.data;
}
export async function getPublicAttachment(id) {
  const response = await OPENDATA().get("/public/data/attachment/" + id, {
    responseType: "blob",
  });
  return response.data;
}
export async function postData(json) {
  const response = await OPENDATA().post("/data", { ...json });
  return response.data;
}
export async function putData(id, json) {
  const response = await OPENDATA().put("/data/" + id, { ...json });
  return response.data;
}
export async function getData() {
  const response = await OPENDATA().get("/data");
  return response.data;
}
export async function getOneData(id) {
  const response = await OPENDATA().get("/data/" + id);
  return response.data;
}
export async function deleteData(id) {
  const response = await OPENDATA().delete("/data/" + id);
  return response.data;
}
// Data
// Public
export async function getPublicMenu() {
  const response = await OPENDATA().get("/public/menu");
  return response.data;
}
export async function getPublicData(id) {
  const response = await OPENDATA().get("/public/data/" + id);
  return response.data;
}

// Public
